import { combineReducers } from "redux";

import privacypolicy from "../features/admin/privacypolicys/privacypolicy/Slice";

import common from "../features/admin/common/Slice";

const privacypolicys = combineReducers({
  privacypolicy,
  common,
});

export default privacypolicys;